// extracted by mini-css-extract-plugin
export default {"Group":"Group_Group__-tmoQ","verticalAlign":"Group_verticalAlign__JDRgc","spaceBetween":"Group_spaceBetween__8bcCd"};